<template>
  <span :id="facilityId" class="d-inline-block" tabindex="0">
    <button class="map-block facility" disabled role="none">
      <div class="block-info">{{ code }}</div>
    </button>
    <b-popover
      v-if="facilityId && description"
      :target="facilityId"
      variant="primary"
      triggers="hover"
      placement="top"
    >
      {{ description }}
    </b-popover>
  </span>
</template>

<script>
export default {
  name: 'facility',
  props: {
    info: Object,
  },
  data() {
    return {
      facilityId: this.info.facilityId,
      code: this.info.code,
      description: this.info.description,
    };
  },
};
</script>

<style lang="scss">
.facility {
  display: flex;
  flex-direction: column;
  background-color: $light-gray-blue;
  border: 2.5px solid gray;

  border-radius: 5px;
  justify-content: center;

  color: gray !important;
  font-weight: $vb-font-weight-semibold;
  &-info {
    text-align: center;
    font-size: large;
  }
}
</style>
